<template>
  <el-dialog
    center
    width="600px"
    title="添加城市"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="addForm" :rules="addRules" ref="addForm">
      <el-form-item label="名称" :label-width="formLabelWidth" prop="areaName">
        <el-input
          v-model="addForm.areaName"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="邮编" :label-width="formLabelWidth" prop="areaCode">
        <el-input v-model="addForm.areaCode"  placeholder="请输入邮编"></el-input>
      </el-form-item> -->

      <el-form-item label="拼音" :label-width="formLabelWidth" prop="pinyin">
        <el-input v-model="addForm.pinyin" placeholder="请输入拼音"></el-input>
      </el-form-item>

      <el-form-item label="省份" :label-width="formLabelWidth" prop="pareaId">
        <el-cascader
          :options="areaAllList | filterList(areaAllList)"
          placeholder="请选择城市归属省份"
          v-model="addForm.pareaId"
          :label-width="formLabelWidth"
          :props="{ checkStrictly: true }"
          @change="handleChange"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <!-- <div class="tooBox">
        <el-form-item label="经度" :label-width="formLabelWidth" prop="lng">
          <el-input v-model="addForm.lng"   placeholder="请输入经度"></el-input>
        </el-form-item>
        <el-form-item label="纬度" :label-width="formLabelWidth" prop="lat">
          <el-input v-model="addForm.lat"   placeholder="请输入纬度"></el-input>
        </el-form-item>
      </div> -->
      <div class="tooBox">
        <el-form-item
          label="是否热门"
          :label-width="formLabelWidth"
          prop="isHot"
        >
          <el-switch
            v-model="addForm.isHot"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="是否城市"
          :label-width="formLabelWidth"
          prop="city"
        >
          <el-switch
            v-model="addForm.isArea"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAdd">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addFormApi } from '@/api/areaApi.js';
import { formData, formRules } from '../form.js';
import { mapGetters } from 'vuex';
export default {
  name: 'addCity',
  data() {
    return {
      formLabelWidth: '122px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      addForm: { ...formData }, // 添加表单数据
      addRules: formRules, // 表单的验证规则
    };
  },
  inject: ['getAreaList'], // 爷组件的方法
  computed: {
    ...mapGetters(['areaAllList']),
  },
  methods: {
    // 展开城市选择
    // handleExpandChange(val) {
    //   // console.log(val);
    // },
    handleChange(val) {
      // console.log(val);
      this.addForm.level = val.length;
    },
    submitAdd() {
      try {
        this.$refs.addForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          /*
          parenId 表示只要父节点
          大于1表示选中孙父节点 中国/广东，则选中后者
          等于1表示选中了 中国，则选中数组第0位
        */
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          this.addForm.pareaId =
            this.addForm.pareaId.length > 1
              ? this.addForm.pareaId[1]
              : this.addForm.pareaId[0];
          await addFormApi({ ...this.addForm, areaId });
          this.$message.success('添加成功!');
          this.dialogFormVisible = false;
          this.addForm = {};
          // 重新获取tree数据
          this.getAreaList();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" sconped>
.tooBox {
  display: flex;
}
</style>
